import type { ComponentProps } from 'react'

import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import Link from 'next/link'

import * as styles from './breadcrumbs-item.styles'

type Props = {
  isCurrent?: boolean
} & ComponentProps<typeof Link>

export const BreadcrumbsItem = ({
  isCurrent = false,
  children,
  ...props
}: Props) => (
  <li css={styles.breadcrumbsItem}>
    <Link
      aria-current={isCurrent ? 'page' : undefined}
      css={styles.link}
      legacyBehavior={false}
      {...props}
    >
      <Typography
        color={isCurrent ? 'textPrimary' : 'textTertiary'}
        component="span"
        variant="b2"
      >
        {children}
      </Typography>
    </Link>
  </li>
)
